export const dlRegistrationSuccessEvent = ({ email, firstName = '', lastName = '' }) => {
    window.dataLayer.push({
        event: 'registration',
        reg_data: {
            firstName,
            lastName,
            email
        },
        customer: {
            email
        }
    });
};
